export default function formatAccountNumber(accountNumber) {
  return(
    accountNumber?.replaceAll('*', String.fromCharCode(8226))
  )
}